import React from 'react';

const HeaderHelp = ({ id, label, align = 'left', children }) => (
  <span className="group relative inline-flex normal-case">
    <button
      type="button"
      className="inline-flex h-3.5 w-3.5 items-center justify-center rounded-full border border-gray-400 text-[9px] font-bold leading-none text-gray-500"
      aria-describedby={id}
    >
      <span aria-hidden="true">?</span>
      <span className="sr-only">{label}</span>
    </button>
    <span
      id={id}
      role="tooltip"
      className={`pointer-events-none absolute top-full z-30 mt-1 hidden w-64 whitespace-normal rounded-md bg-[#172b3c] px-2 py-1.5 text-left text-[11px] font-normal normal-case leading-snug text-white shadow group-hover:block group-focus-within:block ${
        align === 'right' ? 'right-0' : 'left-0'
      }`}
    >
      {children}
    </span>
  </span>
);

export default HeaderHelp;
